import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdminSidebar from "./Sidebar";
import AdminMobileBottomNav from "./MobileBottomNav";

export default function AdminLayout({ children }) {
  const navigate = useNavigate();
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token || user.role !== 'admin') {
      navigate("/login");
      return;
    }

    setIsReady(true);
  }, [navigate]);

  useEffect(() => {
    if (isSidebarOpen) {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "";
      };
    }
    document.body.style.overflow = "";
  }, [isSidebarOpen]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login");
  };

  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);

  const handleNavigate = () => {
    setSidebarOpen(false);
  };

  if (!isReady) {
    return null;
  }

  return (
    <div className="admin-container" style={{ width: '100%' }}>
      {/* Overlay for mobile when sidebar is open */}
      {isSidebarOpen && (
        <div 
          className="admin-sidebar-overlay" 
          onClick={toggleSidebar}
        />
      )}

      <div className={`admin-sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <AdminSidebar onNavigate={handleNavigate} />
      </div>

      <div className="admin-content-wrapper">
        <header className="admin-header">
           <div className="admin-header-title" style={{ display: 'flex', alignItems: 'center' }}>
             <button className="sidebar-toggle" onClick={toggleSidebar} style={{ marginRight: '15px', background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer' }}>
                <span>☰</span>
             </button>
             <h3 style={{ margin: 0 }}>Panel Administrasi</h3>
           </div>
           <div className="admin-header-right" style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
             <div className="admin-user-info" style={{ textAlign: 'right', display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontWeight: 600, fontSize: '0.9rem', color: 'var(--secondary)' }}>{user.name}</span>
                <span style={{ fontSize: '0.75rem', color: 'var(--text-light)' }}>Administrator</span>
             </div>
             <button 
                onClick={handleLogout}
                style={{
                  padding: '8px 16px',
                  borderRadius: '10px',
                  background: '#FFF5F5',
                  color: '#C53030',
                  border: '1px solid #FED7D7',
                  fontWeight: 600,
                  fontSize: '0.85rem',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseOver={(e) => { e.currentTarget.style.background = '#FED7D7' }}
                onMouseOut={(e) => { e.currentTarget.style.background = '#FFF5F5' }}
             >
                Keluar
             </button>
           </div>
        </header>
        <main className="admin-main">
          {children}
        </main>
        <AdminMobileBottomNav />
      </div>
    </div>
  );
}
